import { TimerActions, TimerActionTypes } from '../actions/timer.actions';

export interface TimerState {
  time: number;
  warnings: number[];
  restart: boolean;
  ended: boolean;
}

export const initialState: TimerState = {
  time: 0,
  warnings: [],
  restart: false,
  ended: false,
};

export function timerReducer(state = initialState, action: TimerActions): TimerState {
  switch (action.type) {
    case TimerActionTypes.INIT: {
      return { ...initialState, time: action.timeRemaining, warnings: action.warnings } as TimerState;
    }
    case TimerActionTypes.RESTART: {
      return {
        ...state,
        time: state.time - 1,
        restart: true,
      } as TimerState;
    }
    case TimerActionTypes.WARNING: {
      return {
        ...state,
        time: action.payload,
      } as TimerState;
    }
    case TimerActionTypes.END: {
      return { ...initialState, ended: true } as TimerState;
    }
    case TimerActionTypes.SET_TIMER: {
      return { ...state, time: action.payload.time } as TimerState;
    }
    default: {
      return state;
    }
  }
}
